import React from 'react';
import { chatStyles } from './utils';

const Input = React.forwardRef(({
  type = 'text',
  disabled = false,
  placeholder,
  value,
  onChange,
  onKeyPress,
  className = '',
  ...props
}, ref) => {
  const inputStyle = {
    display: 'flex',
    height: '36px',
    width: '100%',
    borderRadius: chatStyles.radius,
    border: `1px solid ${chatStyles.border}`,
    backgroundColor: chatStyles.input,
    paddingLeft: '12px',
    paddingRight: '12px',
    fontSize: '14px',
    outline: 'none',
    transition: 'border-color 0.2s',
    ':focus': {
      borderColor: chatStyles.primary,
      boxShadow: `0 0 0 2px ${chatStyles.primary}20`,
    },
    ':disabled': {
      cursor: 'not-allowed',
      opacity: 0.5,
    },
    '::placeholder': {
      color: chatStyles.mutedForeground,
    }
  };

  return (
    <input
      ref={ref}
      type={type}
      disabled={disabled}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      onKeyPress={onKeyPress}
      style={inputStyle}
      className={className}
      {...props}
    />
  );
});

Input.displayName = 'Input';

const Textarea = React.forwardRef(({
  disabled = false,
  placeholder,
  value,
  onChange,
  onKeyPress,
  rows = 3,
  className = '',
  ...props
}, ref) => {
  const textareaStyle = {
    display: 'flex',
    minHeight: '60px',
    width: '100%',
    borderRadius: chatStyles.radius,
    border: `1px solid ${chatStyles.border}`,
    backgroundColor: chatStyles.input,
    padding: '8px 12px',
    fontSize: '14px',
    outline: 'none',
    transition: 'border-color 0.2s',
    resize: 'none',
    fontFamily: 'inherit',
    ':focus': {
      borderColor: chatStyles.primary,
      boxShadow: `0 0 0 2px ${chatStyles.primary}20`,
    },
    ':disabled': {
      cursor: 'not-allowed',
      opacity: 0.5,
    },
    '::placeholder': {
      color: chatStyles.mutedForeground,
    }
  };

  return (
    <textarea
      ref={ref}
      disabled={disabled}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      onKeyPress={onKeyPress}
      rows={rows}
      style={textareaStyle}
      className={className}
      {...props}
    />
  );
});

Textarea.displayName = 'Textarea';

export { Input, Textarea };